export const APP_CACHE_VERSION = "20260807-product-cache-v3";

export function appendCacheVersion(url, itemVersion) {
  const source = String(url || "").trim();
  if (!source || /^(data:|blob:)/i.test(source)) {
    return source;
  }
  const version = `${APP_CACHE_VERSION}-${itemVersion || "0"}`;
  const separator = source.includes("?") ? "&" : "?";
  return `${source}${separator}_pv=${encodeURIComponent(version)}`;
}
